import { WarningIcon } from '../../svgs/icons';

export const MobileWarning = () => (
  <div className="block md:hidden p-4 bg-white border-primary border-b-2 flex items-center">
    <WarningIcon className="h-8 w-8 mr-4 flex-shrink-0" />
    <p className="text-lg flex-grow">For the best experience, we recommend a desktop browser.</p>
  </div>
);
